/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-07 10:04:32
 * @LastEditors: huangfuchunmei
 * @message: 使用指南-视频
 */
import React from "react";
import { videoList } from '@/common/const'
import VideoDialog from "@/components/VideoDialog";
import styles from "../../index.module.scss";
import LazyMedia from "@/components/LazyMedia"

interface IProps {
  ctry: string;
  words: Record<string, string>;
}

const icon_video_play = require('../../../assets/icon_video_play.svg')

const VideoGuidance = (props:IProps) => {
  const {ctry, words} = props
  const [isShowVideo, setIsShowVideo] = React.useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = React.useState('');

  const handleClick = (videoUrl: string) => {
    setIsShowVideo(true);
    setCurrentVideoUrl(videoUrl);
  }

  return (
    <section className={styles['section']}>
      <h2 className={styles['section-title']}>
        {words?.support_usage_guide_video_title}
        {/* Video Guidance */}
      </h2>
      <div className={styles['video-list']}>
        {videoList.map(item => (
          <div className={styles['video-item']} key={item.id}>
            <div className={styles['video-cover']}>
              <LazyMedia type="image" LazyClassName="full-wh" src={item.cover} alt="" className={styles['video-pic']} />
              <div className={styles['video-mask']}>
                <LazyMedia type="image" src={icon_video_play} alt="" className={styles['video-play']} onClick={() => handleClick(item.url)} />
              </div>
            </div>
            <p className={styles['video-title']}>{item.title}</p>
          </div>
        ))}
      </div>
      {isShowVideo && (
        <VideoDialog words={words} videoUrl={currentVideoUrl} setIsShowVideo={setIsShowVideo} />
      )}
      
    </section>
  )
}
export default VideoGuidance
